(() => {
  const rootSelector = '#diamond-proxy-root';
  const viewOnHandText = 'view on hand';
  const caratSizePattern = /center\s+stone\s+carat\s+size|carat\s+size/i;

  const normalize = (value) => (value || '').replace(/\s+/g, ' ').trim().toLowerCase();

  const exactText = (element, text) => normalize(element.textContent) === text;

  const ensureStyles = () => {
    if (document.getElementById('ffl-nivoda-view-on-hand-placement-style')) return;

    const style = document.createElement('style');
    style.id = 'ffl-nivoda-view-on-hand-placement-style';
    style.textContent = `
      #diamond-proxy-root .ffl-view-on-hand-below-carat-size {
        margin-top: 12px !important;
        margin-bottom: 14px !important;
      }
    `;
    document.head.appendChild(style);
  };

  const findViewOnHandControl = (root) => {
    const candidates = root.querySelectorAll('button, a, [role="button"], div, span');

    for (const element of candidates) {
      if (!exactText(element, viewOnHandText)) continue;

      const clickable = element.closest('button, a, [role="button"]') || element;
      let wrapper = clickable;

      while (
        wrapper.parentElement &&
        wrapper.parentElement !== root &&
        exactText(wrapper.parentElement, viewOnHandText) &&
        wrapper.parentElement.children.length <= 2
      ) {
        wrapper = wrapper.parentElement;
      }

      return wrapper;
    }
  };

  const findCaratSizeAnchor = (root) => {
    const candidates = root.querySelectorAll('legend, label, h1, h2, h3, h4, p, span, div');

    for (const element of candidates) {
      const text = normalize(element.textContent);
      if (!caratSizePattern.test(text)) continue;
      if (element.children.length > 3 && text.length > 80) continue;

      return element.closest('legend, label, h1, h2, h3, h4, p, div') || element;
    }
  };

  const placeControl = () => {
    const root = document.querySelector(rootSelector);
    if (!root) return;

    const control = findViewOnHandControl(root);
    const anchor = findCaratSizeAnchor(root);
    if (!control || !anchor || control === anchor || control.contains(anchor)) return;

    const parent = anchor.parentElement;
    if (!parent || parent === control || control.contains(parent)) return;

    if (control.previousElementSibling === anchor && control.parentElement === parent) {
      control.classList.add('ffl-view-on-hand-below-carat-size');
      return;
    }

    control.classList.add('ffl-view-on-hand-below-carat-size');
    parent.insertBefore(control, anchor.nextSibling);
  };

  const init = () => {
    ensureStyles();
    placeControl();

    const root = document.querySelector(rootSelector);
    if (!root) return;

    let queued = false;
    const observer = new MutationObserver(() => {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(() => {
        queued = false;
        placeControl();
      });
    });

    observer.observe(root, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
